import React from 'react';
import { Error } from './error';
import { Spinner } from './spinner';

// todo: refactor to receive status arrays instead of error and isLoading
const Process = ({ error, isLoading, children }) => (
  <div>
    {error() && <Error {...error()} />}
    {isLoading() && <Spinner />}
    {children}
  </div>
);

export { Process };
